import { Grid, Text, Stack, GridItem } from '@chakra-ui/react';

export const AppFooter = () => (
  <>
    <Grid className='app-footer' templateColumns='repeat(1, 1fr)' gap={6}>
      <GridItem>
        <Text fontWeight='semibold'>We&apos;re here to help</Text>
        <Text>
          Visit our Help Center or contact our support team to receive
          assistance.
        </Text>
      </GridItem>
    </Grid>
    <Grid templateColumns='repeat(4, 1fr)' gap={6}>
      <GridItem colSpan={1}>
        <Text fontWeight='semibold'>Customer Support</Text>
        <Stack direction='column'>
          {/* <Text>800 854-5614</Text> */}
          <Text>Monday - Friday, 7am to 7pm CST</Text>
          <Text>Saturday and Sunday: Closed </Text>
          <Text>email: QuestSupport@experian.com</Text>
        </Stack>
      </GridItem>
      <GridItem colSpan={3} mt={1}>
        <Text fontWeight='semibold'>Technical Support</Text>
        <Stack direction='column' mt={1}>
          <Text>800 854-7201</Text>
          <Text>Monday - Friday, 7am to 7pm CST</Text>
          <Text>Saturday and Sunday: Closed </Text>
          <Text>
            If you need assistance outside of these hours for issues such as a
            <br />
            password reset, please leave a message, and a representative will
            <br />
            contact you as soon as possible
          </Text>
        </Stack>
      </GridItem>
    </Grid>
  </>
);
